// Copyright (c) 2016 Deere & Company

export default [
    ['model'],
    ['customerSummary', 'displayName'],
    ['pin'],
    ['dealer', 'name'],
    ['dealer', 'location', 'city'],
    ['dealer', 'location', 'state'],
    ['dealer', 'account'],
    ['pipCompletionStatus', 'value']
];



// WEBPACK FOOTER //
// ./src/pip/pip-details/state/affected-pin-filter-options.js